var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.06 11.0297H6.43L10.82 6.68966C11.21 6.29966 11.22 5.66966 10.82 5.27966C10.43 4.88966 9.8 4.87966 9.41 5.27966L3.3 11.3197C3.11 11.5097 3 11.7697 3 12.0297C3 12.2897 3.11 12.5497 3.3 12.7397L9.38 18.6897C9.57 18.8797 9.83 18.9797 10.08 18.9797C10.33 18.9797 10.6 18.8797 10.79 18.6797C11.18 18.2897 11.17 17.6497 10.77 17.2697L6.45 13.0397H20.05C20.6 13.0397 21.05 12.5897 21.05 12.0397C21.05 11.4897 20.6 11.0397 20.05 11.0397L20.06 11.0297Z",
  fill: "inherit"
})));
export default SvgArrowLeft;